export const GET_CLUB_BILLING_STATUS = `
  query GetClubBillingStatus($clubId: String!) {
    getClubBillingStatus(clubId: $clubId) {
      clubId
      billingEnabled
      billingState
      nextAction
      billingAccessMode
      trialConsumed
      trialEligible
      checkoutOpensAt
      freeAccessUntil
      status
      currentPeriodEnd
      trialEnd
      billingDetailsOnStripe
      needsBillingDetails
      canStartLocalTrial
      trialStartedLocally
      hasPaymentMethod
      pastDueSince
      cancelAtPeriodEnd
      canViewBilling
      canManageBilling
    }
  }
`;

export const CREATE_CLUB_CHECKOUT_SESSION = `
  mutation CreateClubCheckoutSession($clubId: String!, $language: String) {
    createClubCheckoutSession(clubId: $clubId, language: $language) {
      url
    }
  }
`;

export const CREATE_BILLING_PORTAL_SESSION = `
  mutation CreateBillingPortalSession($clubId: String!, $language: String) {
    createBillingPortalSession(clubId: $clubId, language: $language) {
      url
    }
  }
`;

export const START_CLUB_BILLING_TRIAL = `
  mutation StartClubBillingTrial($clubId: String!) {
    startClubBillingTrial(clubId: $clubId) { clubId }
  }
`;
export const CREATE_CLUB_BILLING_DESTINATION = `
  mutation CreateClubBillingDestination($clubId: String!, $language: String) {
    createClubBillingDestination(clubId: $clubId, language: $language) { url }
  }
`;

export const PREPARE_PAUSED_CLUB_SUBSCRIPTION = `
  mutation PreparePausedClubSubscription($clubId: String!, $language: String, $period: String, $setupSessionId: String) {
    preparePausedClubSubscription(clubId: $clubId, language: $language, period: $period, setupSessionId: $setupSessionId) {
      url
      selectedPlan
      plans { period amount currency }
    }
  }
`;

export const SAVE_CLUB_BILLING_TAX_IDENTITY = `
  mutation SaveClubBillingTaxIdentity($clubId: String!, $country: String!, $nationalTaxId: String!, $vatId: String) {
    saveClubBillingTaxIdentity(clubId: $clubId, country: $country, nationalTaxId: $nationalTaxId, vatId: $vatId)
  }
`;


export const GET_CLUB_INVOICE_DETAILS = `
  query GetClubInvoiceDetails($clubId: String!) {
    getClubInvoiceDetails(clubId: $clubId) { invoiceId country nationalTaxId vatId reason canEdit }
  }
`;
export const SAVE_CLUB_INVOICE_DETAILS = `
  mutation SaveClubInvoiceDetails($clubId: String!, $invoiceId: String!, $nationalTaxId: String!, $vatId: String) {
    saveClubInvoiceDetails(clubId: $clubId, invoiceId: $invoiceId, nationalTaxId: $nationalTaxId, vatId: $vatId)
  }
`;

